import {createSelector} from 'reselect'
import {canManageLicense} from '../../loggedInUser/selectors'

const getLicenseCountDownTipState = state => state.licenseCountDownTip

export const getLicenseCountDaysToExpiration = createSelector(
    getLicenseCountDownTipState,
    (licenseCountDownTip) => licenseCountDownTip.licenseCountDaysToExpiration
)

export const isShowLicenseCountDownTip = createSelector(
    getLicenseCountDaysToExpiration,
    canManageLicense,
    (licenseCountDaysToExpiration, canManageLicense) => licenseCountDaysToExpiration != null && canManageLicense
)


// WEBPACK FOOTER //
// ./web/js/components/licenseCountDownTip/selectors.js